import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 55,
    },
    contentCard: {
        height: 160,
        borderColor: '#666',
        borderWidth: 1,
        borderRadius: 10,
        marginTop: 20,
        paddingHorizontal: 16,
        paddingVertical: 18,
        width: '100%',
    },
    textInfo: {
        fontWeight: 'bold',
        color: '#2C2C2E',
        lineHeight: 30
    },
    textDescription: {
        fontWeight: 'normal',
    },
    contentEdit: {
        position: 'absolute',
        right: 10,
        top: 10
    },
    imgBank: {
        width: 23,
        height: 19,
        position: 'absolute',
        right: 10,
        bottom: 10
    },
    btnAdd: {
        height: 50,
        width: '100%',
        borderColor: '#32BFB1',
        borderWidth: 2,
        borderRadius: 20,
        marginTop: 20,
    },
    textBtn: {
        textAlign: 'center',
        marginTop: 15
    },
    textNotFoundAccounts: {
        textAlign: 'center',
        marginTop: 10,
        marginBottom: 10,
        fontWeight: 'bold'
    }
});

export default styles;
